import AbsencesDetailContents from '../detail/AbsencesDetailContents';

import styles from './AbsencesDetailPanelContent.module.scss';

interface OwnProps {
  studentName?: string | null;
  date?: Date | null;
  contactType?: string | null;
  reason?: string | null;
  goToSchoolAt?: string | null;
  leaveSchoolAt?: string | null;
  diseaseName?: string | null;
  symptom?: string | null;
  bodyTemperature?: string | null;
  doctorsInstruction?: string | null;
  relationship?: string | null;
  transportation?: string | null;
  detailComment?: string | null;
}

const AbsencesDetailPanelContent: React.FC<OwnProps> = (props) => (
  <div className={styles.wrapper}>
    <AbsencesDetailContents {...props} />
  </div>
);

export default AbsencesDetailPanelContent;
